exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TnhewCiyFvv1R2QkmRJiP{display:flex}.TnhewCiyFvv1R2QkmRJiP .PRVyKxKM574PU3Olkd1x0{width:200px;margin-right:10px}.tnw9inSRF639YmOXBxvZu{margin-top:20px;margin-right:50px}._2B5bJf_-LG1KDKFxYEhZrE{margin:10px 0px}._2B5bJf_-LG1KDKFxYEhZrE a.KaQnti43roDGvoHpI3DQg{padding:0px;text-align:left}._3mpAakSyypWLbIGeP9vTTa{display:flex}._3mpAakSyypWLbIGeP9vTTa>div:first-child{margin-right:100px}\n", ""]);

// Exports
exports.locals = {
	"flex": "TnhewCiyFvv1R2QkmRJiP",
	"codeInput": "PRVyKxKM574PU3Olkd1x0",
	"CodePicker": "tnw9inSRF639YmOXBxvZu",
	"generate": "_2B5bJf_-LG1KDKFxYEhZrE",
	"generateUnlimited": "KaQnti43roDGvoHpI3DQg",
	"qrCodes": "_3mpAakSyypWLbIGeP9vTTa"
};